





























































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from 'vuex-class'
import ContactsCollectedSchedule from "@/components/lfs/NewStatistics/GeneralDashboard/ContactsCollectedSchedule.vue";
import ContactsCategory from "@/components/lfs/NewStatistics/GeneralDashboard/ContactsCategory.vue";
import ContactsInterest from "@/components/lfs/NewStatistics/GeneralDashboard/ContactsInterest.vue";
import {pick} from "lodash";
import StandmansRatingListPdf from "@/components/lfs/NewStatistics/GeneralDashboard/StandmansRatingListPdf.vue";

const statistic_v4 = namespace('statistic_v4')

@Component({
  name: 'Report',
  components: {
    StandmansRatingListPdf,
     ContactsInterest, ContactsCategory, ContactsCollectedSchedule}
})

export default class Report extends Vue {
  @statistic_v4.Getter('total') protected total: any
  @statistic_v4.Getter('createdContacts') protected createdContacts: any
  @statistic_v4.Getter('contactAttributes') protected contactAttributes: any
  @statistic_v4.Getter('standmansRating') protected standmansRating: any
  @statistic_v4.Getter('activeStandmans') protected activeStandmans: any
  @statistic_v4.Getter('surveysFilled') protected surveysFilled: any
  @statistic_v4.Getter('loading') protected loading!: any
  @statistic_v4.Getter('error') protected error!: any
  @statistic_v4.Getter('standmansContacts') protected standmansContacts: any
  @statistic_v4.Action('loadPdf') protected loadPdf!: any

  get collectedBadges() {
    if (!this.createdContacts.allContactsCount) return []
    return this.createdContacts.allContactsCount
  }
  get collectedBusinessCards() {
    if (!this.createdContacts.filledSurveysCount) return []
    return this.createdContacts.filledSurveysCount
  }
  get collectedCustomContacts() {
    if (!this.createdContacts.customContacts) return []
    return this.createdContacts.customContacts
  }
  get collectedTimestampShowStart() {
    return this.createdContacts.timestampShowStart
  }
  get categories(): any {
    return {
      isNew: { title: this.$t('newstatistics.general.contacts_category.isNew'), color: '#29B450', count: null },
      none: { title: this.$t('newstatistics.general.contacts_category.none'), color: '#D2CCDD', count: null },
      exists: { title: this.$t('newstatistics.general.contacts_category.exists'), color: '#2D9CDB', count: null },
    }
  }
  get contactsCategory() {
    const cat = this.contactAttributes['category']
    for (let item in cat) {
      this.categories[item].count = cat[item]
    }
    return this.categories
  }
  get contactsInterest() {
    return this.contactAttributes.hotLevel
  }
  get ratingByCount() {
    return this.standmansRating.byCount
  }
  get ratingByFilling() {
    return this.standmansRating.byFilling
  }
  get totalSurveys() {
    if (!Object.keys(this.surveysFilled).length) return {}
    return pick(this.surveysFilled, ['countFilledSurveys', 'shardsWithFilledSurveys', 'filedSurveysToday'])
  }
  get normalizedSurveysFilled() {
    if (!Object.keys(this.surveysFilled).length) return []
    return this.surveysFilled.filledSurveys.filter((el: any) => el.count)
  }
  get totalCollected() {
    return this.total.sumContacts ? this.total.sumContacts : 0
  }

  get isCollectedChartFilled() {
    return this.collectedBadges.length || this.collectedBusinessCards.length || this.collectedCustomContacts.length
  }
  get isContactsCategoryFilled() {
    return this.contactAttributes.hotLevel.cold || this.contactAttributes.hotLevel.hot || this.contactAttributes.hotLevel.warm || this.contactAttributes.hotLevel.none
  }
  get isContactsInterestFilled() {
    return this.contactsInterest.cold || this.contactsInterest.hot || this.contactsInterest.warm || this.contactsInterest.none
  }
  get totalCount() {
    return pick(this.total,
      ['sumContacts','allScans', 'scansToday', 'timestampShowStart','scansBadges','scansBusinessCard','sumCustomContact'])
  }

  protected mounted() {
    this.loadPdf()
  }
}
